import {useEffect, useState} from "react";
import axiosInstance from "../../../variables/api/axiosInstance";
import {Col, ConfigProvider, DatePicker, Row, Select, Typography} from "antd";
import frFR from "antd/locale/fr_FR";

const {RangePicker} = DatePicker

const {Title} = Typography

const OrdersFiltering = ({setOrders, source, orders}) => {
    const [membres, setMembres] = useState([]);
    const filteringOnCompanies = (companies) => {
        console.log(companies);
        if (companies.length === 0) return setOrders(source);
        setOrders(source.filter(order => companies.includes(order.compagnie.code)))
    };

    const dateFiltering = (_, dateString) => {
        if (dateString[0] === "" || dateString[1] === "") return setOrders(source);
        console.log(new Date(dateString[0]).toISOString(), new Date(dateString[1]));
        setOrders(orders?.filter(order => getAuthorizedDate(order?.actionsSurCommande) >= new Date(dateString[0]).toISOString() && getAuthorizedDate(order?.actionsSurCommande) <= new Date(dateString[1]).toISOString()));
    };

    const getAuthorizedDate = (actions) => {
        const action = actions.find((a) => a.action === "AUTORISER");
        return action?.dateAction;
    }


    useEffect(() => {
        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                let membs = [];
                res.data.forEach((memb, index) => {
                    membs.push({
                        key: index, text: memb.raisonSociale, value: memb.code, data: memb,
                    });
                });
                membs.push({
                    key: "DTRF", text: "DTRF", value: "DTRF",
                });
                membs.push({
                    key: "STCA", text: "STCA", value: "STCA",
                });
                setMembres(membs);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);


    return (<>
        <Row>
            <Col span={12}>
                <Title level={5}>Filtrage par compagnie</Title>
                <Select
                    mode="multiple"
                    placeholder="Filtre par compagnie"
                    onChange={filteringOnCompanies}
                    options={membres.map((memb) => ({
                        label: memb.text, value: memb.value, key: memb.value
                    }))}
                    style={{
                        width: '90%'
                    }}
                />
            </Col>
            <Col span={12}>
                <Title level={5}>Filtrage par date</Title>
                <ConfigProvider locale={frFR}>
                    <RangePicker
                        onChange={dateFiltering}
                        style={{
                            width: '90%'
                        }}
                    />
                </ConfigProvider>

            </Col>
        </Row>
    </>)
}

export default OrdersFiltering;